import Full from 'Container/Full'

// component
const InvoiceUpload = () => import('Views/invoice/InvoiceUpload')

// helpers
import { checkAuthorization, checkIp } from '../helpers/helpers.js'

export default {
  path: '/upload',
  component: Full,
  meta: { requiresAuth: true },
  beforeEnter(to, from, next) {
    checkAuthorization(next)
    checkIp(next)
    next()
  },
  children: [
    {
      path: '',
      component: InvoiceUpload,
      meta: { title: '読み取り' },
    },
  ],
}
